(function () {
  'use strict';
  var d = document, root = d.documentElement, body = d.body;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var R = (window.LOWW && window.LOWW.routes) || {};

  /* ---------- Skip intro ---------- */
  var skip = $('.curtain__skip');
  if (skip) skip.addEventListener('click', function () { root.classList.add('no-curtain'); });

  /* ---------- Overlay helpers ---------- */
  function Layer(el, cls) {
    var last = null;
    return {
      el: el,
      open: function (focusEl) {
        if (!el) return; last = d.activeElement;
        el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); body.classList.add(cls);
        setTimeout(function () { (focusEl || $('button, input, a', el) || el).focus && (focusEl || $('button, input, a', el) || el).focus(); }, 60);
      },
      close: function () {
        if (!el || !el.classList.contains('is-open')) return;
        el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); body.classList.remove(cls);
        if (last && last.focus) last.focus();
      },
      isOpen: function () { return !!el && el.classList.contains('is-open'); }
    };
  }

  /* ---------- Full-screen menu ---------- */
  var menuBtn = $('.menu-btn'), overlay = $('#menu-overlay');
  if (menuBtn && overlay) {
    var setMenu = function (open) {
      body.classList.toggle('menu-open', open);
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      menuBtn.firstElementChild.textContent = open ? 'Close' : 'Menu';
      overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
    };
    menuBtn.addEventListener('click', function () { setMenu(!body.classList.contains('menu-open')); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
    overlay.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
  }

  /* ---------- Cart drawer (Shopify AJAX Cart API + Section Rendering) ---------- */
  var cartLayer = Layer($('#cart-drawer'), 'cart-open');
  var cartPage = body.classList.contains('template-cart');
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
  }
  function renderCart(sections) {
    if (!sections || !sections['cart-drawer'] || !cartLayer.el) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var n = $('[data-cart-content]', doc);
    if (n) { $('[data-cart-content]', cartLayer.el).innerHTML = n.innerHTML; var c = $('[data-count]', n); if (c) setCount(parseInt(c.getAttribute('data-count'), 10) || 0); }
  }
  function cartError(msg) {
    var e = $('[data-cart-error]', cartLayer.el || d); if (e) e.textContent = msg || '';
  }
  function post(url, body_, json) {
    var opts = { method: 'POST', headers: { 'Accept': 'application/json' }, body: body_ };
    if (json) opts.headers['Content-Type'] = 'application/json';
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong.'); return j; });
    });
  }
  function addToCart(fd, btn, errEl) {
    fd.append('sections', 'cart-drawer'); fd.append('sections_url', window.location.pathname);
    if (btn) btn.classList.add('is-busy');
    if (errEl) errEl.textContent = '';
    return post((R.cartAdd || '/cart/add') + '.js', fd).then(function (j) {
      if (btn) { btn.classList.remove('is-busy'); btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1600); }
      renderCart(j.sections);
      if (!cartPage) cartLayer.open(); else window.location.reload();
    }).catch(function (err) {
      if (btn) btn.classList.remove('is-busy');
      if (errEl) errEl.textContent = err.message; else { cartLayer.open(); cartError(err.message); }
    });
  }
  function changeLine(line, qty) {
    post((R.cartChange || '/cart/change') + '.js', JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname }), true)
      .then(function (j) { renderCart(j.sections); })
      .catch(function (err) { cartError(err.message); });
  }

  /* ---------- Search overlay (Predictive Search API) ---------- */
  var searchLayer = Layer($('#search-overlay'), 'search-open');
  var sInput = $('#search-input'), sOut = $('[data-search-results]'), sTimer = 0, sCtl = null;
  if (sInput && sOut) {
    sInput.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = sInput.value.trim();
      if (q.length < 2) { sOut.innerHTML = ''; return; }
      sTimer = setTimeout(function () {
        if (sCtl) sCtl.abort(); sCtl = window.AbortController ? new AbortController() : null;
        var url = (R.predictive || '/search/suggest') + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,collection,article,page&resources[limit]=6&resources[limit_scope]=each';
        sOut.innerHTML = '<p class="release__meta">Searching...</p>';
        fetch(url, sCtl ? { signal: sCtl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var n = $('#predictive-search-results', doc);
          sOut.innerHTML = n ? n.innerHTML : '';
        }).catch(function (e) { if (e.name !== 'AbortError') sOut.innerHTML = '<p class="release__meta">Search is unavailable right now.</p>'; });
      }, 250);
    });
  }

  /* ---------- Size guide modal ---------- */
  var sizeLayer = Layer($('#size-guide'), 'modal-open');

  /* ---------- Product page: gallery + variants + form ---------- */
  function showMedia(root_, id) {
    $$('.pgal__item', root_).forEach(function (f) { f.classList.toggle('is-active', f.getAttribute('data-media-id') === String(id)); });
    $$('.pgal__thumb', root_).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id)); });
  }
  $$('[data-product]').forEach(function (p) {
    var vjson = $('[data-variants]', p), form = $('#product-form', p) || $('form[data-type="add-to-cart-form"]', p);
    var variants = []; try { variants = JSON.parse(vjson.textContent); } catch (e) {}
    var idInput = $('[data-variant-id]', p), btn = $('[data-add-btn]', p), label = $('[data-add-label]', p), priceEl = $('[data-price]', p), err = $('[data-form-error]', p);
    function selected() { return $$('.opt', p).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function update() {
      if (!variants.length) return;
      var sel = selected();
      var v = variants.filter(function (x) { return sel.every(function (s, i) { return x.options[i] === s; }); })[0];
      if (!v) { btn.disabled = true; label.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      var tpl = $('template[data-price-for="' + v.id + '"]', p); if (tpl) priceEl.innerHTML = tpl.innerHTML;
      btn.disabled = !v.available; label.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (err) err.textContent = '';
      if (v.featured_media && v.featured_media.id) showMedia(p, v.featured_media.id);
      if (window.history && history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
    }
    $$('.opt input', p).forEach(function (i) { i.addEventListener('change', update); });
    $$('.pgal__thumb', p).forEach(function (t) { t.addEventListener('click', function () { showMedia(p, t.getAttribute('data-thumb')); }); });
    if (form) form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      if (btn.disabled) return;
      addToCart(new FormData(form), btn, err);
    });
  });

  /* ---------- Related products ---------- */
  $$('[data-reco]').forEach(function (box) {
    var url = box.getAttribute('data-url'); if (!url || !window.fetch) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var n = $('[data-reco]', doc);
      if (n && n.innerHTML.trim()) { box.innerHTML = n.innerHTML; $$('.pcard', box).forEach(function (c) { c.classList.add('reveal', 'reveal--tile', 'in'); }); }
    }).catch(function () {});
  });

  /* ---------- Collection filters auto-apply ---------- */
  $$('[data-filter-form]').forEach(function (f) { f.addEventListener('change', function () { f.submit(); }); });

  /* ---------- Global click delegation ---------- */
  d.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-add]'))) {
      e.preventDefault();
      var fd = new FormData(); fd.append('id', t.getAttribute('data-variant')); fd.append('quantity', '1');
      addToCart(fd, t, null); return;
    }
    if ((t = e.target.closest('[data-toggle-sizes]'))) {
      var box = t.parentNode.querySelector('.pcard__sizes'), open = box.hidden;
      box.hidden = !open; t.setAttribute('aria-expanded', open ? 'true' : 'false'); return;
    }
    if (e.target.closest('[data-cart-open]') && cartLayer.el && !cartPage) { e.preventDefault(); if (menuBtn && body.classList.contains('menu-open')) menuBtn.click(); cartLayer.open(); return; }
    if (e.target.closest('[data-cart-close]')) { cartLayer.close(); return; }
    if ((t = e.target.closest('[data-qty-change]'))) { changeLine(parseInt(t.getAttribute('data-line'), 10), parseInt(t.getAttribute('data-qty-change'), 10)); return; }
    if (e.target.closest('[data-search-open]')) { searchLayer.open(sInput); return; }
    if (e.target.closest('[data-search-close]')) { searchLayer.close(); return; }
    if (e.target.closest('[data-size-guide-open]')) { sizeLayer.open(); return; }
    if (e.target.closest('[data-modal-close]')) { sizeLayer.close(); return; }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { cartLayer.close(); searchLayer.close(); sizeLayer.close(); }
  });

  /* ---------- Split big text into masked words ---------- */
  $$('[data-words]').forEach(function (el) {
    var words = el.textContent.trim().split(/\s+/);
    el.setAttribute('aria-label', words.join(' '));
    el.innerHTML = words.map(function (w, i) {
      return '<span class="w" aria-hidden="true"><span style="--w:' + i + '">' + w.replace(/</g, '&lt;') + '</span></span>';
    }).join(' ');
  });

  /* ---------- Tag elements for entrance effects ---------- */
  $$('.pgrid').forEach(function (g) {
    $$('.pcard', g).forEach(function (t, i) { t.classList.add('reveal', 'reveal--tile'); t.style.setProperty('--i', i % 4); });
  });
  $$('.acard').forEach(function (t, i) { t.classList.add('reveal', 'reveal--tile'); t.style.setProperty('--i', i % 3); });
  $$('.art__item').forEach(function (t, i) { t.classList.add('reveal', 'reveal--tile'); t.style.setProperty('--i', i % 3); });
  $$('.story__item, .band__media').forEach(function (t) { t.classList.add('reveal'); });
  $$('.section h2.chrome-text').forEach(function (el) { el.classList.add('sweep'); });
  $$('.footer__mark').forEach(function (el) { el.classList.add('reveal'); });

  /* ---------- Matrix rain + particles (canvas, Block 01 intro) ---------- */
  function Rain(canvas, o) {
    o = o || {};
    var ctx = canvas.getContext('2d'), w = 0, h = 0, drops = [], run = false, last = 0, parts = [];
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5), size = o.size || 16;
    var glyphs = o.glyphs || 'ｱｲｳｴｵｶｷｸｹｺ0123456789';
    function resize() {
      var r = canvas.getBoundingClientRect();
      w = canvas.width = Math.max(1, Math.floor(r.width * dpr));
      h = canvas.height = Math.max(1, Math.floor(r.height * dpr));
      var cols = Math.ceil(w / (size * dpr)); drops = [];
      for (var i = 0; i < cols; i++) drops.push(-Math.random() * 40);
      parts = [];
      for (var p = 0; p < (o.particles || 0); p++) parts.push({ x: Math.random() * w, y: Math.random() * h, r: (Math.random() * 1.4 + .4) * dpr, vx: (Math.random() - .5) * .25 * dpr, vy: -(Math.random() * .35 + .08) * dpr, a: Math.random() * .6 + .2 });
    }
    function frame(t) {
      if (!run) return; requestAnimationFrame(frame);
      if (t - last < 1000 / (o.fps || 24)) return; last = t;
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = 'rgba(0,0,0,' + (o.fade || .1) + ')'; ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'source-over';
      var s = size * dpr; ctx.font = s + 'px monospace';
      for (var i = 0; i < drops.length; i++) {
        var ch = glyphs.charAt(Math.floor(Math.random() * glyphs.length)), y = drops[i] * s;
        var green = Math.random() < (o.ghost || .05);
        ctx.fillStyle = green ? 'rgba(245,215,110,.75)' : (Math.random() < .08 ? 'rgba(232,238,238,.9)' : 'rgba(212,175,55,.8)');
        ctx.fillText(ch, i * s, y);
        if (y > h && Math.random() > .975) drops[i] = 0;
        drops[i] += o.speed || .6;
      }
      for (var p = 0; p < parts.length; p++) {
        var q = parts[p]; q.x += q.vx; q.y += q.vy;
        if (q.y < -4) { q.y = h + 4; q.x = Math.random() * w; }
        ctx.fillStyle = 'rgba(245,215,110,' + q.a + ')'; ctx.beginPath(); ctx.arc(q.x, q.y, q.r, 0, 6.283); ctx.fill();
      }
    }
    resize();
    return { start: function () { if (run || reduce || saveData) return; run = true; requestAnimationFrame(frame); }, stop: function () { run = false; }, resize: resize };
  }
  var rains = [], small = window.innerWidth < 800;
  $$('[data-fx]').forEach(function (cv) {
    if (reduce || saveData || !cv.getContext) return;
    var r = Rain(cv, { size: small ? 14 : 18, fade: .09, fps: 22, speed: .5, particles: small ? 16 : 36, ghost: .05 }); rains.push(r);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es[0].isIntersecting ? r.start() : r.stop(); }).observe(cv);
  });
  window.addEventListener('resize', function () { rains.forEach(function (r) { r.resize(); }); });

  /* ---------- Filters (store product types) ---------- */
  $$('[data-filter-group]').forEach(function (sec) {
    var chips = $$('[data-filter]', sec), items = $$('[data-cat]', sec);
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var f = c.getAttribute('data-filter');
        chips.forEach(function (x) { var on = x === c; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        items.forEach(function (it) {
          var show = f === 'all' || it.getAttribute('data-cat') === f; it.hidden = !show;
          if (show) { it.classList.add('in'); if (!reduce) { it.classList.remove('pop'); void it.offsetWidth; it.classList.add('pop'); } }
        });
      });
    });
  });

  /* ---------- Videos in the art grid: play only while visible ---------- */
  var vids = $$('.art__video, .bg-video');
  if (reduce) { vids.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); }); }
  else if ('IntersectionObserver' in window) {
    var vo = new IntersectionObserver(function (es) {
      es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { v.muted = true; vo.observe(v); });
  }

  /* ---------- Lightbox: images, GIFs and videos ---------- */
  var lb = $('#lightbox');
  if (lb) {
    var lbImg = $('img', lb), lbVid = $('.lightbox__video', lb), lbCap = $('figcaption', lb), lbCount = $('.lightbox__count', lb);
    var lbClose = $('.lightbox__close', lb), lbPrev = $('.lightbox__prev', lb), lbNext = $('.lightbox__next', lb);
    var items = [], idx = 0, opener = null, tx = 0;
    var stopVideo = function () { lbVid.pause(); lbVid.removeAttribute('src'); lbVid.removeAttribute('poster'); lbVid.load(); };
    var show = function (i) {
      idx = (i + items.length) % items.length;
      var it = items[idx], isVideo = it.getAttribute('data-type') === 'video';
      stopVideo();
      lbCap.textContent = it.getAttribute('data-caption') || '';
      lbCount.textContent = (idx + 1) + ' / ' + items.length;
      if (isVideo) {
        lbImg.hidden = true; lbVid.hidden = false;
        lbVid.poster = it.getAttribute('data-poster') || ''; lbVid.src = it.getAttribute('data-video');
        var p = lbVid.play(); if (p && p.catch) p.catch(function () {});
      } else {
        lbVid.hidden = true; lbImg.hidden = false; lbImg.classList.remove('is-in');
        lbImg.onload = function () { lbImg.classList.add('is-in'); };
        lbImg.src = it.getAttribute('data-full'); lbImg.alt = it.getAttribute('data-alt') || '';
        var n = items[(idx + 1) % items.length];
        if (n && n.getAttribute('data-type') !== 'video') { var pre = new Image(); pre.src = n.getAttribute('data-full'); }
      }
    };
    var openLb = function (btn) {
      var scope = btn.closest('[data-lightbox-scope]') || d;
      items = $$('[data-lightbox]', scope).filter(function (e) { return !e.hidden; });
      opener = btn; lb.hidden = false; body.classList.add('lb-open');
      lbPrev.hidden = lbNext.hidden = items.length < 2;
      show(Math.max(0, items.indexOf(btn))); lbClose.focus();
    };
    var closeLb = function () { lb.hidden = true; body.classList.remove('lb-open'); stopVideo(); lbImg.removeAttribute('src'); if (opener) opener.focus(); };
    d.addEventListener('click', function (e) { var b = e.target.closest('[data-lightbox]'); if (b) openLb(b); });
    lbClose.addEventListener('click', closeLb);
    lbPrev.addEventListener('click', function () { show(idx - 1); });
    lbNext.addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    lb.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 60 && items.length > 1) show(idx + (dx < 0 ? 1 : -1)); }, { passive: true });
    d.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowRight' && items.length > 1) show(idx + 1);
      else if (e.key === 'ArrowLeft' && items.length > 1) show(idx - 1);
      else if (e.key === 'Tab') {
        var f = [lbClose, lbPrev, lbNext].filter(function (x) { return !x.hidden; });
        var i = f.indexOf(d.activeElement); e.preventDefault();
        f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      }
    });
  }

  /* ---------- Easter egg: type "loww" ---------- */
  var egg = $('#egg'), eggRain = null, buf = '', eggTimer = 0;
  function closeEgg() { if (!egg || egg.hidden) return; egg.hidden = true; clearTimeout(eggTimer); if (eggRain) eggRain.stop(); }
  function openEgg() {
    if (!egg || !egg.hidden) return; egg.hidden = false;
    if (!reduce && !saveData) {
      if (!eggRain) eggRain = Rain($('canvas', egg), { size: 20, fade: .07, fps: 30, speed: 1, glyphs: 'LOWW01ｱｲｳｴｵ', ghost: .12 });
      eggRain.resize(); eggRain.start();
    }
    eggTimer = setTimeout(closeEgg, 8000);
  }
  if (egg) {
    egg.addEventListener('click', closeEgg);
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeEgg();
      var t = (e.target && e.target.tagName) || '';
      if (/input|textarea|select/i.test(t) || e.key.length !== 1) return;
      buf = (buf + e.key.toLowerCase()).slice(-4);
      if (buf === 'loww') { buf = ''; openEgg(); }
    });
  }

  /* ---------- Motion layer ---------- */
  var targets = $$('.reveal, .wipe, h2.sweep, [data-words]');
  var sections = $$('.section');
  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('in'); });
    sections.forEach(function (el) { el.classList.add('in-view'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
  targets.forEach(function (el) { io.observe(el); });
  var so = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in-view'); so.unobserve(e.target); } });
  }, { threshold: 0.05 });
  sections.forEach(function (el) { so.observe(el); });

  var artFrames = $$('.art__frame'), running = false;
  function frame() {
    var y = window.scrollY || 0, vh = window.innerHeight;
    root.style.setProperty('--p', clamp(y / Math.max(1, root.scrollHeight - vh), 0, 1).toFixed(4));
    var gi = $('.ghero__img'); if (gi) gi.style.setProperty('--ty', (Math.min(y, vh * 1.2) * 0.18).toFixed(1) + 'px');
    artFrames.forEach(function (f, i) {
      var r = f.getBoundingClientRect(); if (r.bottom < -80 || r.top > vh + 80) return;
      var c = (r.top + r.height / 2 - vh / 2) / vh, sp = [14, 30, 20][i % 3];
      var media = f.firstElementChild; if (media && media.style) media.style.setProperty('--ty', (c * -sp).toFixed(1) + 'px');
    });
    running = false;
  }
  function kick() { if (running) return; running = true; requestAnimationFrame(frame); }
  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', kick);
  kick();

  /* ---------- Pointer effects (desktop) ---------- */
  if (fine) {
    var cur = d.createElement('div');
    cur.className = 'cursor'; cur.setAttribute('aria-hidden', 'true'); body.appendChild(cur);
    var mx = -100, my = -100, cx = -100, cy = -100, letters = $$('.sintro .ch'), orb = $('.sintro');
    window.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (orb) {
        var rr = orb.getBoundingClientRect();
        if (my > rr.top && my < rr.bottom) {
          orb.style.setProperty('--mx', ((mx / window.innerWidth) * 2 - 1).toFixed(3));
          orb.style.setProperty('--my', (((my - rr.top) / rr.height) * 2 - 1).toFixed(3));
          letters.forEach(function (l) {
            var r = l.getBoundingClientRect();
            l.style.setProperty('--k', clamp(1 - Math.hypot(mx - (r.left + r.width / 2), my - (r.top + r.height / 2)) / 260, 0, 1).toFixed(3));
          });
        }
      }
    }, { passive: true });
    (function loop() {
      cx += (mx - cx) * 0.18; cy += (my - cy) * 0.18;
      cur.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
      requestAnimationFrame(loop);
    })();
    d.addEventListener('mouseover', function (e) {
      var lab = e.target.closest('[data-cursor]');
      var isMedia = e.target.closest('.art__btn');
      cur.textContent = lab ? lab.getAttribute('data-cursor') : (isMedia ? (e.target.closest('[data-type="video"]') ? 'Play' : 'View') : '');
      cur.classList.toggle('has-label', !!(lab || isMedia));
      cur.classList.toggle('is-hover', !lab && !isMedia && !!e.target.closest('a, button, label'));
    });
    $$('.btn').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + ((e.clientX - (r.left + r.width / 2)) * 0.22).toFixed(1) + 'px,' + ((e.clientY - (r.top + r.height / 2)) * 0.3).toFixed(1) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }
})();
